import { render, staticRenderFns } from "./VCollapse.vue?vue&type=template&id=85088810&scoped=true&"
import script from "./VCollapse.vue?vue&type=script&lang=js&"
export * from "./VCollapse.vue?vue&type=script&lang=js&"
import style0 from "./VCollapse.vue?vue&type=style&index=0&id=85088810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85088810",
  null
  
)

export default component.exports